import { Component, Input, OnInit } from '@angular/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { LanguageSwitchService } from 'src/app/services/language-switch.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
@Input() ENV: any;
@Input() lang: any;
  URLS: { APPLICATION_HEADER_URL: string; APPLICATION_FOOTER_URL: string; APPLICATION_NAVIATION_URL: string; APPLICATION_QLINKS_FOOTER_URL: string; };
  constructor(
    private LSS: LanguageSwitchService,
    private UTS: UtilitiesService) { }

  ngOnInit(): void {
    this.ENV = this.UTS.getENV();
    this.lang = this.UTS.getLocaleLanguage();
    if (this.lang == 'ar') {
      this.UTS.setAHURL(`ar${AppSettings.APPLICATION_HEADER_URL}`);
      this.UTS.setAFURL(`ar${AppSettings.APPLICATION_FOOTER_URL}`);
      this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
      this.URLS = {
        APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
        APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
        APPLICATION_NAVIATION_URL:
          'ar' + AppSettings.APPLICATION_NAVIATION_URL,
        APPLICATION_QLINKS_FOOTER_URL:
          'ar' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
      };
    } else {
      this.LSS.setLanguage('en');
      this.LSS.changeLanguage();
      this.UTS.setAHURL(`en${AppSettings.APPLICATION_HEADER_URL}`);
      this.UTS.setAFURL(`en${AppSettings.APPLICATION_FOOTER_URL}`);
      this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
      this.URLS = {
        APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
        APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
        APPLICATION_NAVIATION_URL:
          'en' + AppSettings.APPLICATION_NAVIATION_URL,
        APPLICATION_QLINKS_FOOTER_URL:
          'en' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
      };
    }
  }

}
